var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('KTCard',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('div',{staticClass:"d-flex justify-content-between"},[_c('b-card-title',[_vm._v("لیست تخفیف ها")])],1),_c('list-table')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }